export default __webpack_public_path__ + "static/media/death.0eb8ff35.mp3";